import React, { createContext, useEffect, useState} from "react";
import { validateToken } from "../../../../apis/Api";
import { getValidateToken } from "../../../../utils/service";
import RouteConstants from "../../../../constants/routesContent.json";
import LoginConstant from "../../../../constants/contentFile.json";
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie'; 

export const LoginOTPContext = createContext({});

export const LoginOtpContextProvider = ({ children }) => {
  const loginConstants = LoginConstant.errorMessages;
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const [tokenManagingCompleted, setTokenManagingCompleted] = useState(false);
  const [tokenNumber, setTokenNumber] = useState(null);

  useEffect(() => {
    const url = window.location.href;
    const match = url.match(/\?(\d+)\/token/);

    if (match) {
      setTokenNumber(parseInt(match[1], 10)); 
    } else {
      setTokenNumber('Not found');
    }
  }, []);

  const manageToken = async () => {
    removeCookie('intentToken', { path: '/' });
    
    try {
      const validToken = getValidateToken();
      
      if (validToken) {
         const result = await validateToken(validToken);

         if (result?.data?.statusCode === 200) {
          setTokenManagingCompleted(true);
           setCookie('intentToken', validToken, { path: '/' });
         } else {
          setTokenManagingCompleted(true);
         }
      } else {
        setTokenManagingCompleted(true);
      }
    } catch (error) {
      setTokenManagingCompleted(true);
    }
  }

  const loginOtpClik = async () => {
    navigate(RouteConstants.LOGIN_REGESTEDMOBILENUMBER);
    // try {
    //   const validToken = getValidateToken();
      
    //   if (validToken) {
    //      const result = await validateToken(validToken);
    //      if (result?.data?.statusCode === 200) {
    //         navigate(RouteConstants.LOGIN_REGESTEDMOBILENUMBER, {
    //           state: validToken,
    //         });
    //      } else {
    //         navigate(RouteConstants.LINK_EXPIRED, { state: loginConstants.noActiveRequest });
    //      }
    //   } else {
    //     navigate(RouteConstants.LOGIN_REGESTEDMOBILENUMBER, {
    //       state: null,
    //     });
    //   }
    // } catch (error) {
    //   navigate(RouteConstants.LINK_EXPIRED, { state: loginConstants.noActiveRequest });
    // }
  };

  const loginCreditailsClik = () => {
    navigate(RouteConstants.LOGIN_OTP_CREDENTIALS);
  };

  useEffect(() => {
    if (!tokenManagingCompleted) {
      manageToken();
    }

    if (tokenManagingCompleted && cookies.xAccessToken && cookies.supplierId) {
      navigate(RouteConstants.ORDER_DETAILS);
    }
  },[tokenManagingCompleted]);


  useEffect(() => {
     window.history.pushState(null, null,  window.location.href);
     const windowBackManage = () => navigate(1);
     window.addEventListener('popstate', windowBackManage);

     return () => {
       window.removeEventListener('popstate', windowBackManage);
     }
  }, []);

  const providerValue = {
    loginOtpClik,
    loginCreditailsClik,
    tokenNumber
  };

  return (
    <LoginOTPContext.Provider value={providerValue}>
      {children}
    </LoginOTPContext.Provider>
  );
};
